import type { Search } from './updateSearchParams';

const removeSearchParam = (search: Search, name: string) => {
    const params = new URLSearchParams(search);
    params.delete(name);

    return params;
};

export const removeSearchParams = (search: Search, names: string[]) => {
    return names.reduce(
        (searchParams, name) => removeSearchParam(searchParams, name),
        search
    );
};

export default removeSearchParam;
